import { ListItemText, MenuItem } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import React, { FC } from "react";
import ViewEditSelect, { ViewEditSelectProps } from "../view-edit-select";
import { GetJog, JogsForUsers } from "../../../reducers/states/agency/jogs";

type ViewEditSelectJogProps =
  Omit<ViewEditSelectProps["props"], "id" | "label" | "value"> & {
    id?: string;
    label?: string;
    maxSelectedCount?: number;
    userPrimaryJogId?: string;
    value: string[]; // this enforces a string[] instead of string or string[] from ViewEditSelectProps
    // todo: jcavner: Perhaps add a field to decide which set of jogs to use. I.e., JogsForUsers, JogsForDispatchFiltering, or JogsForIncidents. Or a field to simply pass that set of options in?  
}

const ViewEditSelectJog: FC<ViewEditSelectJogProps> = (props) => {
  // const jogOptions = props.userPrimaryJogId?.length ? JogsForUsers : JogsForIncidents;
  const jogOptions = JogsForUsers;

  return (
    <ViewEditSelect
      props={{
        disableShrinkLabel: props.disableShrinkLabel,
        id: props.id ?? "jogs",
        label: props.label ?? "JOGs",
        isEdit: props.isEdit,
        size: props.size ?? "small",
        value: props.value,
        menuProps: {
          PaperProps: {
            style: { overflow: "auto", width: "auto" },
          },
        },
        multiple: props.multiple,
        tooltip: props.tooltip,
        handleInputChange: props.handleInputChange,
        renderValue: (value) => {
          if (Array.isArray(value)) {
            const shortNames = value.map((id) => GetJog(id)?.shortName);
            // filter undefined values (in case event is associated with unfinalized JOG, which JogMap.get() returns undefined for)
            // todo: might need to handle this on incident detail form, too.
            return shortNames.filter((n) => n).join(", ");
          }

          return value;
        },
      }}
    >
      {jogOptions.map((jog) => {
        const isMaxCountSelected = !!props.maxSelectedCount && props.value.length >= props.maxSelectedCount;
        const isPrimaryJog = jog.id === props.userPrimaryJogId;
        const isSelected = props.value.includes(jog.id);
        const SelectionIcon = isSelected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;
        const primaryText = jog.name + (isPrimaryJog ? " (user's primary JOG)" : "");
        const secondaryText = jog.name.startsWith(jog.shortName.split(" ")[0]) ? "" : jog.shortName;
        const isDisabled = isPrimaryJog || (isMaxCountSelected && !isSelected);

        // todo: jcavner: If I refactor this component for "single" selection, e.g., "Primary JOG", I will need logic to display items without the checkbox here.
        return (
          <MenuItem key={jog.id} value={jog.id} disabled={isDisabled}>
            <SelectionIcon fontSize="small" style={{ marginRight: 8, padding: 9, boxSizing: "content-box" }} />
            <ListItemText primary={primaryText} secondary={secondaryText} />
          </MenuItem>
        );
      })}
    </ViewEditSelect>
  );
};

export default ViewEditSelectJog;
